import { render, staticRenderFns } from "./IndexIns.vue?vue&type=template&id=26c98175&"
import script from "./IndexIns.vue?vue&type=script&lang=js&"
export * from "./IndexIns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports